import React, { ReactNode } from 'react';

import { Tooltip } from '@material-ui/core';

type Props = {
  isSelected: boolean;
  disabledMessage?: string;
  helperLabel?: string;
  onClick: () => void;
  children: ReactNode;
  error?: string;
}
export function UserPermissionToggle ({ isSelected, disabledMessage, helperLabel, onClick, children, error }: Props) {
  const errorClasses = error ? 'border border-error text-error' : '';
  const toggleClasses = isSelected ? 'bg-blue-200 text-blue-900' : `bg-gray-100 font-light ${error ? '' : 'text-gray-600'}`;

  return (
    <div className="mr-5">
      <Tooltip title={disabledMessage || error || ''}>
        <button
          onClick={disabledMessage ? undefined : onClick}
          className={`rounded h-16 flex items-center px-6 text-sm w-40 text-left transition-colors ${errorClasses} ${toggleClasses}`}
        >
          { children }
        </button>
      </Tooltip>
      {helperLabel && (
        <span className="absolute mt-2 text-xs font-bold text-gray-600">* {helperLabel}</span>
      )}
    </div>
  );
}
